import { defineStore } from 'pinia';
import api from '../api/index.js';

export const useSegmentsStore = defineStore('segments', {
  state: () => ({
    segments: [],
    loading: false,
    saving: false,
  }),

  actions: {
    async fetchAll() {
      this.loading = true;
      try {
        const { data } = await api.getAll();
        this.segments = data.segments;
      } finally {
        this.loading = false;
      }
    },

    async create(segmentData) {
      const { data } = await api.create(segmentData);
      this.segments.unshift(data);
      return data;
    },

    async update(id, segmentData) {
      const { data } = await api.update(id, segmentData);
      const idx = this.segments.findIndex(s => s.id === id);
      if (idx !== -1) this.segments[idx] = data;
      return data;
    },

    async delete(id) {
      await api.delete(id);
      this.segments = this.segments.filter(s => s.id !== id);
    },
  },
});
